export default __webpack_public_path__ + "static/Motus-6bbcc3c87b70aeccc39156fcd1712e13.png";